// 24-grid line icons, round joins (R9), drawn at a chunky 2.5 stroke in app.css. Paths from the
// approved mockups; box, rules and pie give Products, Catalogue rules and Reports their own glyphs.
const PATHS = {
  home: 'M4 11l8-7 8 7v9a1 1 0 01-1 1h-4v-6h-6v6H5a1 1 0 01-1-1v-9z',
  receipt: 'M6 3h12v18l-3-2-3 2-3-2-3 2V3zM9 8h6M9 12h6',
  pin: 'M12 21s-7-6.2-7-11.5a7 7 0 0114 0C19 14.8 12 21 12 21z',
  bag: 'M4 9h16l-1 11H5L4 9zM8 9V6a4 4 0 018 0v3',
  person: 'M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0',
  team: 'M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2 20a7 7 0 0114 0M16 4.2a3.5 3.5 0 010 6.6M18 13.5a7 7 0 014 6.5',
  list: 'M4 6h16M4 12h16M4 18h10',
  cash: 'M3 7h18v10H3zM12 15a3 3 0 100-6 3 3 0 000 6z',
  scale: 'M5 20h14l-2-11H7L5 20zM9 9a3 3 0 016 0',
  refund: 'M20 12a8 8 0 11-2.3-5.7M20 4v5h-5',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  globe: 'M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3a14 14 0 010 18',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7l1-8z',
  gear: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-2.9 1.2V21a2 2 0 01-4 0v-.1A1.7 1.7 0 008.6 19.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1A1.7 1.7 0 004.6 15H4.5a2 2 0 010-4h.1A1.7 1.7 0 006.3 8.6l-.1-.1a2 2 0 112.8-2.8l.1.1A1.7 1.7 0 0012 4.6V4.5a2 2 0 014 0',
  search: 'M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM15.5 15.5L20 20',
  clock: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3 2',
  flame: 'M12 3c2 3 5 5 5 9a5 5 0 01-10 0c0-2 1-3 2-4 0 2 1 3 2 3 0-3-1-5 1-8z',
  star: 'M12 2l3 6.5 7 1-5 5 1.2 7L12 18l-6.2 3.5L7 14.5l-5-5 7-1z',
  camera: 'M4 8h3l2-3h6l2 3h3v11H4V8zM12 17a3.5 3.5 0 100-7 3.5 3.5 0 000 7z',
  check: 'M5 12.5l4.5 4.5L19 7',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  close: 'M6 6l12 12M18 6L6 18',
  bell: 'M6 16V11a6 6 0 0112 0v5l2 2H4l2-2zM10 21h4',
  bellOff: 'M6 16V11a6 6 0 019.5-4.9M18 11v5l2 2H8M10 21h4M3 3l18 18',
  sun: 'M12 16a4 4 0 100-8 4 4 0 000 8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8 8 0 019.5 4a8 8 0 1010.5 10.5z',
  monitor: 'M3 4h18v12H3zM8 20h8M12 16v4',
  logout: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10',
  swap: 'M7 4L3 8l4 4M3 8h14M17 20l4-4-4-4M21 16H7',
  alert: 'M12 3l10 18H2L12 3zM12 10v4M12 17v.5',
  arrow: 'M5 12h14M13 6l6 6-6 6',
  box: 'M3 8l9-5 9 5v8l-9 5-9-5V8zM3 8l9 5 9-5M12 13v8',
  rules: 'M9 3h6v3H9zM7 4.5H5V21h14V4.5h-2M8.5 11l1.5 1.5 3-3M8.5 16.5h7',
  pie: 'M12 3v9h9a9 9 0 11-9-9zM15 2.6a9 9 0 016.4 6.4H15V2.6z',
  chevronDown: 'M6 9l6 6 6-6',
  chevronLeft: 'M15 6l-6 6 6 6',
  chevronRight: 'M9 6l6 6-6 6',
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 'md', label }: { name: IconName; size?: 'sm' | 'md' | 'lg'; label?: string }) {
  const cls = size === 'sm' ? 'ico sm' : 'ico';
  const style = size === 'lg' ? { width: 32, height: 32 } : undefined;
  return (
    <svg className={cls} style={style} viewBox="0 0 24 24" aria-hidden={label ? undefined : true} role={label ? 'img' : undefined} aria-label={label} focusable="false">
      <path d={PATHS[name]} />
    </svg>
  );
}

const MARK_BODY = 'M97.33 50.34A48 48 0 1 1 69.66 22.67A20 20 0 0 0 97.33 50.34Z';

/** The PopCart mark: body + pop, always one colour (R3.1). */
export function PopMark({ size = 28, tone = 'cream' }: { size?: number; tone?: 'cream' | 'ink' }) {
  const fill = tone === 'cream' ? 'var(--pc-palette-core-cream)' : 'var(--pc-palette-core-ink)';
  return (
    <svg className="mark" width={size} height={size} viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <path fill={fill} d={MARK_BODY} />
      <path fill={fill} d="M91.41 16.59A12 12 0 1 0 115.41 16.59A12 12 0 1 0 91.41 16.59Z" />
    </svg>
  );
}

/**
 * The drawn horizontal lockup (manual §06 "A · Horizontal", symbol #lockH): the mark, then the
 * wordmark whose "o" is the Pop Mark. One colour, taken from `currentColor` (Pop Yellow on Cart
 * Blue = §06 B colours; Cream on Ink = §06 D). Never retyped in a font (§19).
 */
export function Lockup({ width = 240, label = 'PopCart' }: { width?: number; label?: string }) {
  return (
    <svg className="lockup" width={width} viewBox="-322 -60 1328 266" role="img" aria-label={label} focusable="false">
      <g fill="currentColor" transform="translate(-320 -62.4) scale(1.9167)">
        <path d={MARK_BODY} />
        <circle cx="103.41" cy="16.59" r="12" />
      </g>
      <g fill="none" stroke="currentColor" strokeWidth="34">
        <path d="M17 0V200M17 67a60 50 0 1 0 120 0a60 50 0 1 0 -120 0" />
        <path d="M343 0V200M343 67a60 50 0 1 0 120 0a60 50 0 1 0 -120 0" />
        <path d="M610.28 36.22A60 50 0 1 0 610.28 97.78" />
        <path d="M647 67a60 50 0 1 0 120 0a60 50 0 1 0 -120 0M767 0V134" />
        <path d="M813 134V67A60 50 0 0 1 873 17H902" />
        <path d="M914 17H998M944 -40V134" />
      </g>
      <g fill="currentColor" transform="translate(153.72 -27.22) scale(1.39583)">
        <path d={MARK_BODY} />
        <circle cx="103.41" cy="16.59" r="12" />
      </g>
    </svg>
  );
}

/**
 * The §12 pop loop for loaders: the body squashes, the pop dips then leaps toward the top-right,
 * at 50% of the manual's live-loop duration (UI micro-pops). Still under reduced motion.
 */
export function PopLoop({ size = 48 }: { size?: number }) {
  return (
    <svg className="pop-loop" width={size} height={size} viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <path className="pop-body" fill="currentColor" d={MARK_BODY} />
      <circle className="pop-dot" fill="currentColor" cx="103.41" cy="16.59" r="12" />
    </svg>
  );
}
